import label from "@/lang/StaticLabels.js";

// PMKT Navbar  - بازاریابی -----------------------------------------------

let navItems = [
  {
    title: label.modules.pmkt,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PMKTDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
  },
  {
    to: "PMKTFollowUpCartable",
    label: label.menu.followUpCartable,
    metaLabel: label.page.myFollowUpCartable,
    icon: "mdi-checkbox-marked-circle-outline",
    active: false,
    subItems: false,
  },
  {
    to: "PMKTChanceList",
    label: label.menu.salesChances,
    metaLabel: label.page.chance,
    icon: "mdi-view-column-outline",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "mdi-cog-outline",
    active: false,
    subItems: [
      {
        to: "PMKTCampaignType",
        label: label.menu.campaignType,
        metaLabel: label.page.campaignType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTLeadType",
        label: label.menu.leadType,
        metaLabel: label.page.leadType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTLeadProperty",
        label: label.menu.leadProperty,
        metaLabel: label.page.leadProperty,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTLeadSource",
        label: label.menu.leadSource,
        metaLabel: label.page.leadSource,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTLeadEvaluationQuestion",
        label: label.menu.leadEvaluationQuestion,
        metaLabel: label.page.leadEvaluationQuestion,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTChancePriority",
        label: label.menu.chancePriority,
        metaLabel: label.page.chancePriority,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTFailedSaleReason",
        label: label.menu.failedSaleReason,
        metaLabel: label.page.failedSaleReason,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTStrengthWeakness",
        label: label.menu.strengthWeakness,
        metaLabel: label.page.strengthWeakness,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTSaleRegion",
        label: label.menu.saleRegion,
        metaLabel: label.page.saleRegion,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTSaleTeam",
        label: label.menu.saleTeam,
        metaLabel: label.page.saleTeam,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTCompetitorList",
        label: label.menu.competitor,
        metaLabel: label.page.competitor,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.caption.customerRelation,
    icon: "mdi-account-group-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.leads,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMKTLeadList",
            label: label.menu.leadList,
            metaLabel: label.page.lead,
            icon: "mdi-circle-medium",
          },
          {
            to: "PMKTAddLead",
            label: label.menu.leadDefinition,
            metaLabel: label.page.addLead,
            icon: "mdi-circle-medium",
          },
          {
            to: "PMKTLeadSaleTeamAssignment",
            label: label.menu.saleTeamAssignment,
            metaLabel: label.page.saleTeamAssignment,
            icon: "mdi-circle-medium",
          },
          {
            to: "PMKTLeadEvaluationCartable",
            label: label.menu.evaluationCartable,
            metaLabel: label.page.evaluationCartable,
            icon: "mdi-circle-medium",
          },
        ],
      },
      {
        to: "PCRMPersonClubList",
        label: label.menu.customersAndContacts,
        metaLabel: label.page.customerManagement,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTActivityCalendar",
        label: label.menu.activitiesAndCalendar,
        metaLabel: label.page.activitiesAndCalendar,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTProposalContract",
        label: label.menu.proposalsAndContracts,
        metaLabel: label.page.proposalsAndContracts,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTCampaignList",
        label: label.menu.marketingCampaigns,
        metaLabel: label.page.campaignManagement,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.caption.salesManagement,
    icon: "mdi-chart-timeline-variant",
    active: false,
    subItems: [
      {
        to: "PMKTChanceList",
        label: label.menu.salesChances,
        metaLabel: label.page.chance,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTSalesPipeline",
        label: label.menu.salesPipeline,
        metaLabel: label.page.salesPipeline,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PMKTSaleFunnelReport",
        label: label.menu.saleFunnelReport,
        metaLabel: label.page.saleFunnelReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMKTLeadChanceConversionReport",
        label: label.menu.leadChanceConversionReport,
        metaLabel: label.page.leadChanceConversionReport,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
